const operations = {
    state: {
        new: {
            date: new Date().toISOString().substr(0, 10),
            kind: '',
            payment: '',
            posKind: '',
            name: '',
            cost: '',
            price: 0,
            activation: '',
            rates: '',
            advance: '',
            operatorFrom: '',
            operatorTo: '',
            offerName: '',
            paymentKind: '',
            contractKind: '',
            dumping: false,
            gain: 0,
            vat: 0,
            dilapay: 0,
            pos: 0,
            replacements: false,
            coffee: false,
            gift: false,
            pointsSh: false,
            invoice: false,
            b2b: false
        }
    },
    mutations: {
        SET_NEW_OPERATION_DATE(state, payload) {
            state.new.date = payload
        },
        SET_NEW_OPERATION_KIND(state, payload) {
            state.new.kind = payload
        },
        SET_NEW_OPERATION_PAYMENT(state, payload) {
            state.new.payment = payload
        },
        SET_NEW_OPERATION_POS_KIND(state, payload) {
            state.new.posKind = payload
        },
        SET_NEW_OPERATION_NAME(state, payload) {
            state.new.name = payload
        },
        SET_NEW_OPERATION_COST(state, payload) {
            state.new.cost = payload
        },
        SET_NEW_OPERATION_PRICE(state, payload) {
            state.new.price = payload
        },
        SET_NEW_OPERATION_ACTIVATION(state, payload) {
            state.new.activation = payload
        },
        SET_NEW_OPERATION_RATES(state, payload) {
            state.new.rates = payload
        },
        SET_NEW_OPERATION_ADVANCE(state, payload) {
            state.new.advance = payload
        },
        SET_NEW_OPERATION_OPERATOR_FROM(state, payload) {
            state.new.operatorFrom = payload
        },
        SET_NEW_OPERATION_OPERATOR_TO(state, payload) {
            state.new.operatorTo = payload
        },
        SET_NEW_OPERATION_OFFER_NAME(state, payload) {
            state.new.offerName = payload
        },
        SET_NEW_OPERATION_PAYMENT_KIND(state, payload) {
            state.new.paymentKind = payload
        },
        SET_NEW_OPERATION_CONTRACT_KIND(state, payload) {
            state.new.contractKind = payload
        },
        SET_NEW_OPERATION_DUMPING(state, payload) {
            state.new.dumping = payload
        },
        SET_NEW_OPERATION_GAIN(state, payload) {
            state.new.gain = payload
        },
        SET_NEW_OPERATION_VAT(state, payload) {
            state.new.vat = payload
        },
        SET_NEW_OPERATION_DILAPAY(state, payload) {
            state.new.dilapay = payload
        },
        SET_NEW_OPERATION_POS(state, payload) {
            state.new.pos = payload
        },
        SET_NEW_OPERATION_REPLACEMENTS(state, payload) {
            state.new.replacements = payload
        },
        SET_NEW_OPERATION_COFFEE(state, payload) {
            state.new.coffee = payload
        },
        SET_NEW_OPERATION_GIFT(state, payload) {
            state.new.gift = payload
        },
        SET_NEW_OPERATION_POINTS_SH(state, payload) {
            state.new.pointsSh = payload
        },
        SET_NEW_OPERATION_INVOICE(state, payload) {
            state.new.invoice = payload
        },
        SET_NEW_OPERATION_B2B(state, payload) {
            state.new.b2b = payload
        },
        RESET_NEW_OPERATION(state) {
            state.new = {
                date: state.new.date,
                kind: '',
                payment: '',
                posKind: '',
                name: '',
                cost: 0,
                price: 0,
                activation: 0,
                rates: '',
                advance: '',
                operatorFrom: '',
                operatorTo: '',
                offerName: '',
                paymentKind: '',
                contractKind: '',
                dumping: false,
                gain: 0,
                vat: 0,
                dilapay: 0,
                pos: 0,
                replacements: false,
                coffee: false,
                gift: false,
                pointsSh: false,
                invoice: false,
                b2b: false
            }
        }
    },
    getters: {
        getNewOperation: state => state.new,
    }
}

export default operations